export default __webpack_public_path__ + "media/zurb/img/about/talent/talent-img5-06cfbce62d9b1376f43f7658c08ca4fc.png";